import { toast } from "@/components/ToastNotification";

export interface CampoObrigatorio {
  campo: string;
  nomeAmigavel: string;
  validar?: (valor: any) => boolean; // Função customizada de validação
}

/**
 * Valida campos obrigatórios de um formulário e exibe notificação com lista de campos faltantes
 * @param dados - Dados do formulário a serem validados
 * @param camposObrigatorios - Lista de campos obrigatórios com nomes amigáveis
 * @returns true se todos os campos obrigatórios estão preenchidos, false caso contrário
 */
export function validarCamposObrigatorios(
  dados: Record<string, any>,
  camposObrigatorios: CampoObrigatorio[]
): boolean {
  const camposFaltando: string[] = [];

  camposObrigatorios.forEach(({ campo, nomeAmigavel, validar }) => {
    const valor = dados[campo];

    // Se tiver função de validação customizada, usa ela
    if (validar) {
      if (!validar(valor)) {
        camposFaltando.push(nomeAmigavel);
      }
      return;
    }

    // Validação padrão: verifica se o valor existe e não está vazio
    if (valor === null || valor === undefined || valor === '') {
      camposFaltando.push(nomeAmigavel);
      return;
    }

    // Se for array, verifica se tem pelo menos um item
    if (Array.isArray(valor) && valor.length === 0) {
      camposFaltando.push(nomeAmigavel);
      return;
    }

    // Se for string, verifica se não está vazia após trim
    if (typeof valor === 'string' && valor.trim() === '') {
      camposFaltando.push(nomeAmigavel);
      return;
    }

    // Se for número, verifica se é válido
    if (typeof valor === 'number' && (isNaN(valor) || valor <= 0)) {
      camposFaltando.push(nomeAmigavel);
      return;
    }
  });

  if (camposFaltando.length > 0) {
    const mensagemErro = "Por favor, preencha os seguintes campos obrigatórios:\n\n" + 
      camposFaltando.map(campo => `• ${campo}`).join("\n");
    
    toast.error(mensagemErro, {
      duration: 8000,
    });
    
    return false;
  }

  return true;
}

